
export default {
    fields: {
        role_groups: {
            label: 'Send to Roles',
            type: 'checks',
            options: {
                EQUIPMENT_OWNER: "All Equipment Owners",
                EQUIPMENT_OWNER_ADMIN: "All Equipment Owner Admins",
                PROGRAM_ADMIN: "All Program Admins",
                PROJECT_MANAGER: "All Project Managers / Owners Reps",
            }
        },
        // equipment_conditions: {
        //     label: 'Send to any Equipment Owners with...',
        //     type: 'checks',
        //     options: {
        //         FLAGGED_IN_AUDIT: "equipment flagged in audit",
        //         NON_COMPLIANT: "non-compliant equipment",
        //     }
        // },
        subject: {
            label: 'Subject',
            type: 'text',
        },
        message: {
            label: 'Message',
            type: 'rich',
        }
    }
}